import { Directive, Input } from '@angular/core';

@Directive({
    selector: `
        div[wdxListGroupItem],
        li[wdxListGroupItem],
        button[wdxListGroupAction],
        a[wdxListGroupAction]
    `,
    standalone: false,
    host: {
        class: 'list-group-item',
        '[class.list-group-item-action]': 'listGroupAction',
    },
})
export class ListGroupItemDirective {
    private _listGroupAction = false;
    get listGroupAction(): boolean {
        return this._listGroupAction;
    }
    @Input() set wdxListGroupAction(listGroupAction: boolean) {
        this._listGroupAction = listGroupAction !== undefined;
    }
}
